import * as React from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { DataTable } from './DataTable'
import CompletedCourseDialog from './CompletedCourseDialog'
import { Filters } from './Filters'
import { Button } from '~/lib/ui/button'

export default function Page() {
  const { t } = useTranslation('Page')

  const handleSearchForCoursesClick = () => {
    window.location.href = '/research_learning/learn'
  }

  return (
    <div className="flex min-h-[67vh] flex-col gap-4">
      <div className="flex items-center justify-between max-md:flex-col">
        <div className="md:w-3/4">
          <h1 className="py-2">{t('my_courses')}</h1>
          <p>{t('description')}</p>
        </div>
        <Button onClick={handleSearchForCoursesClick}>{t('search')}</Button>
      </div>
      <div className="flex flex-row justify-between gap-4 max-md:py-4">
        <div className="flex flex-row items-center gap-2 whitespace-nowrap">
          <Filters />
        </div>
      </div>
      <DataTable />
      <CompletedCourseDialog />
    </div>
  )
}
